import React from 'react';
import Hero from './components/student-council/Hero';
import Main from './components/student-council/Main';

const StudentCouncil = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default StudentCouncil;